<template>
  <div class="container">
    <template v-if="totalOrders">
      <!-- Table desing begin -->
      <div class="d-none d-sm-block">
        <table id="cart" class="table table-hover">
          <thead>
            <tr>
              <th scope="col" style="width: 25%">Nro. Orden</th>
              <th scope="col" style="width: 25%">Fecha</th>
              <th scope="col" style="width: 25%">Total</th>
              <th scope="col" style="width: 25%" class="text-center">Estatus</th>
              <th scope="col" style="width: 25%">Acciones</th>
            </tr>
          </thead>
          <desktop-order v-for="order in orderList" :order="order" :key="order.id" />
        </table>
      </div>
      <!-- Table desing end -->

      <!-- Responsive desing begin -->
      <div class="d-block d-sm-none">
        <div class="list-group">
          <mobile-order v-for="order in orderList" :order="order" :key="order.id" />
        </div>
      </div>
      <!-- Responsive desing end -->
    </template>
    <template v-else-if="totalOrders === 0">
      <div class="alert alert-primary text-center h2" role="alert">
        Aún no tiene órdenes registradas, puede comenzar cuando quiera haciendo
        <router-link to="/home">click aquí</router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const DesktopOrder = () => import("./DesktopOrder.vue");
const MobileOrder = () => import("./MobileOrder.vue");
import { getOrdersApi } from "@/api/modules";
const ITEMS_PER_PAGE = 15;
export default {
  computed: {
    ...mapGetters(["currentUser", "rate"])
  },
  data() {
    return {
      loaderColor: "#5cb85c",
      loaderSize: "50px",
      displayList: false,
      page: 1,
      search: "",
      bottom: true,
      orderList: [],
      totalOrders: null
    };
  },
  components: {
    DesktopOrder,
    MobileOrder
  },
  created() {
    this.getOrders();
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
  },
  watch: {
    bottom(bottom) {
      if (bottom && this.getValidateBottom()) {
        this.page++;
        this.getOrders();
      }
    }
  },
  methods: {
    ...mapActions(["addMessage"]),
    async getOrders() {
      const start = (this.page - 1) * ITEMS_PER_PAGE;
      const end = this.page * ITEMS_PER_PAGE - 1;
      const payload = {
        range: [start, end],
        filter: {
          ClientId: localStorage.ClientId
        }
      };
      let serviceResponse = await getOrdersApi(payload);
      if (serviceResponse.status) {
        this.orderList = [...this.orderList, ...serviceResponse.data];
        this.totalOrders = serviceResponse.total;
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    getValidateBottom() {
      return this.orderList.length != this.totalOrders;
    }
  }
};
</script>

<style lang="scss" scoped>
.list-shopping-cart-leave-active {
  transition: all 0.4s;
}

.list-shopping-cart-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.table-sm {
  font-size: 0.875rem;
  /deep/ h4 {
    font-size: 1.25rem;
  }
}
</style>
